import { render } from "./CrmNewsCard.vue?vue&type=template&id=6eb364ed&scoped=true"
import script from "./CrmNewsCard.vue?vue&type=script&lang=js"
export * from "./CrmNewsCard.vue?vue&type=script&lang=js"

import "./CrmNewsCard.vue?vue&type=style&index=0&id=6eb364ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb364ed"]])

export default __exports__